<template>
  <section class="margin">
      <div class="flex">
      <h1>
          Our online sessions
      </h1>
      <img  src="../../assets/underline.png" alt="">
      <h4>Holistic development in a fun package to take your kids from gadget monkey to the monkey pose. <br> Lifelong wellness is just a click away.</h4>
  <img class="border responsive" src="../../assets/onlinesession.png" alt="">
  </div>
  </section>
</template>

<script>
export default {

}
</script>

<style scoped>

.flex{
    display: flex;
    align-items: center;
    flex-direction: column;
    height: 725px;
    justify-content: space-evenly;
    text-align: center;
    margin-top: 100px;
    width: 80%;
    margin: auto;
    
}
.margin{
    margin-top: 120px;
}
h1{
    color: #791E94;
    font-weight: 500;
    font-family: 'Original Surfer', cursive;
    font-size: 3rem;
}
h4{
    color: #44526B;
    font-weight: 500;
    line-height: 150%;
}
.border{
    border: 25px solid #F0A202;
    border-radius: 20px;
}

@media (max-width: 1080px){
    .responsive {
  width: 100%;
  height: auto;
}
}
</style>